import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-slate-800 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <img
              src="https://static.readdy.ai/image/a9d6aff03562300b57162884cb61551b/7fbf09dbcfaa601672c5e7d5615b1c01.png"
              alt="Revivacorp"
              className="h-12 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-gray-300 leading-relaxed mb-6">
              The trusted turnaround partner for distressed small and mid-market
              businesses. We deliver empathetic, affordable, and structured
              solutions on a fixed fee and fixed timeline.
            </p>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-wider text-gray-400 mb-6 font-semibold">
              Our Services
            </h4>
            <ul className="space-y-4">
              <li>
                <Link
                  to="/services"
                  className="text-white hover:text-teal-400 transition-colors cursor-pointer"
                >
                  Cash Flow Coach
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="text-white hover:text-teal-400 transition-colors cursor-pointer"
                >
                  Business Turnaround
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="text-white hover:text-teal-400 transition-colors cursor-pointer"
                >
                  Fiduciary Services
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="text-white hover:text-teal-400 transition-colors cursor-pointer"
                >
                  Litigation Consulting
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="text-white hover:text-teal-400 transition-colors cursor-pointer"
                >
                  Capital Solutions
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="text-white hover:text-teal-400 transition-colors cursor-pointer"
                >
                  CXO Services
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-wider text-gray-400 mb-6 font-semibold">
              Company
            </h4>
            <ul className="space-y-4">
              <li>
                <Link
                  to="/about"
                  className="text-white hover:text-teal-400 transition-colors cursor-pointer"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/resources"
                  className="text-white hover:text-teal-400 transition-colors cursor-pointer"
                >
                  Resources
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-white hover:text-teal-400 transition-colors cursor-pointer"
                >
                  Contact Us
                </Link>
              </li>
              <li>
                <Link
                  to="/complaint-opt-in"
                  className="text-white hover:text-teal-400 transition-colors cursor-pointer"
                >
                  Submit a Complaint
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <div className="rounded-lg overflow-hidden h-72 w-full">
              <img
                src="https://public.readdy.ai/ai/img_res/9409a53dcdd85e0dcf09e4681e30c751.jpg"
                alt="JBS Consulting Office"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>

        <div className="border-t border-slate-700 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-400">
            © 2025 Revivacorp. All rights reserved.
          </p>
          <div className="flex gap-8 text-sm">
            <Link
              to="/privacy-policy"
              className="text-gray-400 hover:text-white transition-colors cursor-pointer"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms-of-service"
              className="text-gray-400 hover:text-white transition-colors cursor-pointer"
            >
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}